<template>
  <template v-if="checkPlatform">
    <slot />
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useGlobalStore } from "shared/stores/global";

const props = defineProps<{
  cisionOne?: boolean;
  streem?: boolean;
}>();

const globalStore = useGlobalStore();

const checkPlatform = computed<boolean>(() => {
  if (props.cisionOne) {
    return globalStore.isCisionOne;
  }

  if (props.streem) {
    return globalStore.isStreem;
  }

  return false;
});
</script>
